//banner-api .js

import axios from 'axios'
import { API_URL } from '@/config/api.config'


const bannerAPI = {
    /**
     * 获取Banner列表
     */
    getBannerList: async () => {
        try {
            const response = await axios.get(`${API_URL}/banner`);
            return response.data;
        } catch (error) {
            console.error('获取Banner列表失败:', error);
            throw error;
        }
    },



    /**
     * 批量更新Banner
     */
    batchUpdateBanner: async (formData) => {
        try {
            const response = await axios.put(`${API_URL}/banner/batch`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('批量更新Banner失败:', error);
            throw error;
        }
    },


    /**
     * Banner重新排序
     */
    reorderBanner: async () => {
        try {
            const response = await axios.put(`${API_URL}/banner/reorder`);
            return response.data;
        } catch (error) {
            console.error('Banner重新排序失败:', error);
            throw error;
        }
    },

    /**
     * Banner跳转链接选项
     */
    bannerLink: async () => {
        try {
            const response = await axios.get(`${API_URL}/banner/link`);
            return response.data;
        } catch (error) {
            console.error('获取Banner跳转链接选项失败:', error);
            throw error;
        }
    }
};

export default bannerAPI;